// extracted by mini-css-extract-plugin
module.exports = {"remainingSymbolsCount":"styles_remainingSymbolsCount___34rT","warning":"styles_warning__q1JsU"};